// Pictures.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import socialwork1 from '../Components/img/Socialwork/socialwork14.jpg';
import socialwork2 from '../Components/img/Socialwork/socialwork3.jpg';
import socialwork3 from '../Components/img/Socialwork/socialwork10.jpg';
import socialwork4 from '../Components/img/Socialwork/socialwork16.jpg';

const Pictures = () => {
  const navigate = useNavigate();

  const images = [socialwork1, socialwork2, socialwork3, socialwork4];

  return (
    <Container>
      <Row className="g-4 mb-4">
  {images.map((img, index) => (
    <Col xs={12} md={3} key={index}>
      <Image src={img} rounded fluid />
    </Col>
  ))}
</Row>

   <div className="text-center mb-4">
  <Button
    style={{
      backgroundColor: '#2c3e50',      // custom blue
      borderColor: '#13baab',
      color: 'white',
      padding: '10px 30px',
      fontWeight: 'bold',
      fontSize: '16px',
      transition: '0.3s ease',
    }}
    onMouseOver={(e) => (e.target.style.backgroundColor = '#2c3e50')}
    onMouseOut={(e) => (e.target.style.backgroundColor = '#13baab')}
    onClick={() => navigate('/Social_work')}
  >
    View More
  </Button>
</div>

    </Container>
  );
};

export default Pictures;
